<div class="fe-capacities-container">
  <div class="spinner-container" *ngIf="spinnerBoolean">
    <div class="spinner"></div>
    <div class="spinner-text">Loading Water Mapping data...</div>
  </div>

  <div class="table-actions-bar">
    <div class="table-title">WATER Flow Network</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">
      Clear All
    </button>
    <button *ngIf="selectedRows.length > 0" (click)="clearSelection()">
      Clear Select
    </button>
    <button *ngIf="showCancel" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <div *ngIf="dropdownLoading" class="dropdown-loading">
    Loading dropdown options...
  </div>

  <div class="table-container" [ngClass]="{ hidden: spinnerBoolean }">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-1"></div>
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div class="text-wrap">
              {{ col.header }}
              <span *ngIf="col.required" class="required-asterisk" title="Required">*</span>
            </div>
            <div class="filter-icon-container" *ngIf="col.filterable">
              <img
                class="filter-icon"
                [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16"
                height="16"
                alt="Filter"
                [title]="isFilterActive(col.field) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                (click)="openFloatingFilter($event, col.field)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <cdk-virtual-scroll-viewport
        itemSize="56"
        class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
      >
        <div
          class="table-body-row"
          [ngClass]="{ 'new-row': row.isNew }"
          *cdkVirtualFor="let row of data; let i = index"
          (mouseenter)="hoveredRowIndex = i"
          (mouseleave)="hoveredRowIndex = null"
        >
          <div class="table-header-cell fixed-width-cell-1">
            <span
              *ngIf="hoveredRowIndex === i"
              style="cursor: pointer; font-size: 16px"
              (click)="copyRow(i)"
              title="Copy this row"
            >
              📋
            </span>
          </div>

          <div class="table-header-cell fixed-width-cell-2">
            <input
              type="checkbox"
              [checked]="selectedRows.includes(row)"
              (change)="toggleRowSelection(row, $event)"
            />
          </div>

          <!-- Region -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.region || null">
              <ng-container *ngIf="isIdentityFieldEditable(row); else readOnlyRegion">
                <select
                  [(ngModel)]="row.region"
                  (ngModelChange)="onRegionChange(row, $event)"
                >
                  <option value="">-- Select Region --</option>
                  <option *ngFor="let region of getRegionOptionsForRow(row)" [value]="region">
                    {{ region }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyRegion>
                <div class="readonly-cell-value" [attr.data-full-value]="row.region || '-'"><span class="readonly-cell-text">{{ row.region || '-' }}</span></div>
              </ng-template>
            </div>
          </div>

          <!-- FE DEV Area -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.developmentArea || null">
              <ng-container *ngIf="isIdentityFieldEditable(row); else readOnlyDevelopmentArea">
                <select
                  [(ngModel)]="row.developmentArea"
                  (ngModelChange)="onDevelopmentAreaChange(row, $event)"
                >
                  <option value="">-- Select FE DEV Area --</option>
                  <optgroup label="Development Area" *ngIf="getDevelopmentAreaOptionsForRow(row).length > 0">
                    <option *ngFor="let area of getDevelopmentAreaOptionsForRow(row)" [value]="area">
                      {{ area }}
                    </option>
                  </optgroup>
                  <optgroup label="Sub Development Area" *ngIf="getSubDevelopmentAreaOptionsForRow(row).length > 0">
                    <option *ngFor="let area of getSubDevelopmentAreaOptionsForRow(row)" [value]="area">
                      {{ area }}
                    </option>
                  </optgroup>
                </select>
              </ng-container>
              <ng-template #readOnlyDevelopmentArea>
                <div class="readonly-cell-value" [attr.data-full-value]="row.developmentArea || '-'"><span class="readonly-cell-text">{{ row.developmentArea || '-' }}</span></div>
              </ng-template>
            </div>
          </div>

          <!-- FE Facility Name -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.facilityName || null">
              <ng-container *ngIf="isIdentityFieldEditable(row); else readOnlyFacilityName">
                <select
                  [(ngModel)]="row.facilityName"
                  (ngModelChange)="onFacilityNameChange(row, $event)"
                >
                  <option value="">-- Select FE Facility Name --</option>
                  <option *ngFor="let facility of getFacilityNameOptionsForRow(row)" [value]="facility">
                    {{ facility }}
                  </option>
                </select>
              </ng-container>
              <ng-template #readOnlyFacilityName>
                <div class="readonly-cell-value" [attr.data-full-value]="row.facilityName || '-'"><span class="readonly-cell-text">{{ row.facilityName || '-' }}</span></div>
              </ng-template>
            </div>
          </div>

          <!-- Interconnection 1 -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.interConnection1 || null">
              <select
                [(ngModel)]="row.interConnection1"
                (focus)="onInterconnectionDropdownOpen(row)"
                (ngModelChange)="onInterConnectionChange(row, 'interConnection1', $event)"
              >
                <option value="">-- Select Interconnection 1 --</option>
                <option *ngFor="let int of getDropdownOptionsForRow(row, 'interConnection1')" [value]="int">
                  {{ int }}
                </option>
              </select>
            </div>
          </div>

          <!-- Interconnection 2 -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.interConnection2 || null">
              <select
                [(ngModel)]="row.interConnection2"
                (focus)="onInterconnectionDropdownOpen(row)"
                (ngModelChange)="onInterConnectionChange(row, 'interConnection2', $event)"
              >
                <option value="">-- Select Interconnection 2 --</option>
                <option *ngFor="let int of getDropdownOptionsForRow(row, 'interConnection2')" [value]="int">
                  {{ int }}
                </option>
              </select>
            </div>
          </div>

          <!-- Interconnection 3 (Optional) -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.interConnection3 || null">
              <select
                [(ngModel)]="row.interConnection3"
                (focus)="onInterconnectionDropdownOpen(row)"
                (ngModelChange)="onInterConnectionChange(row, 'interConnection3', $event)"
              >
                <option value="">-- Select Interconnection 3 --</option>
                <option *ngFor="let int of getDropdownOptionsForRow(row, 'interConnection3')" [value]="int">
                  {{ int }}
                </option>
              </select>
            </div>
          </div>

          <!-- Interconnection 4 (Optional) -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.interConnection4 || null">
              <select
                [(ngModel)]="row.interConnection4"
                (focus)="onInterconnectionDropdownOpen(row)"
                (ngModelChange)="onInterConnectionChange(row, 'interConnection4', $event)"
              >
                <option value="">-- Select Interconnection 4 --</option>
                <option *ngFor="let int of getDropdownOptionsForRow(row, 'interConnection4')" [value]="int">
                  {{ int }}
                </option>
              </select>
            </div>
          </div>

          <!-- Disposal Outlet Name -->
          <div class="table-header-cell">
            <div class="cell-wrapper value-hover-card" [attr.data-full-value]="row.disposalOutletName || null">
              <select
                [(ngModel)]="row.disposalOutletName"
                (focus)="onInterconnectionDropdownOpen(row)"
                (ngModelChange)="onDisposalOutletChange(row, $event)"
              >
                <option value="">-- Select Disposal Outlet --</option>
                <option *ngFor="let outlet of getDropdownOptionsForRow(row, 'disposalOutletName')" [value]="outlet">
                  {{ outlet }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <div class="loading-more" *ngIf="loading">
    <div class="loading-spinner"></div>
    <span>Loading more data...</span>
  </div>

  <div
    class="floating-filter-dropdown"
    #floatingFilterPanel
    *ngIf="showFloatingFilter"
    [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }"
  >
    <!-- Multi-select filter -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'multi-select'">
      <input
        type="text"
        [(ngModel)]="filterSearch[activeFilter]"
        placeholder="Search..."
      />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input
            type="checkbox"
            [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)"
          />
          <span>{{ getFilterOptionLabel(option) }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export Water Flow Network</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>
